import FileCopy from '@material-ui/icons/FileCopy';
import React from 'react';
import { withTooltip } from './format';
import { mediumGray } from './theme';
import { showSuccessMessage } from './toast';

type CopyToClipboardProps<T = object> = {
  data: () => T;
  tooltip?: (a?: T) => string;
  successMessage?: (a?: T) => string;
  htmlColor?: string;
  style?: React.CSSProperties;
};

export function CopyToClipboard({
  data,
  tooltip,
  successMessage,
  htmlColor,
  style,
}: CopyToClipboardProps) {
  const tip = tooltip ? tooltip : () => 'Copy to Clipboard';
  const success = successMessage ? successMessage : () => 'Copied to Clipboard';

  const onCopy = (e: any) => {
    e.stopPropagation();
    const a = data();
    if (a) {
      window.navigator.clipboard.writeText(JSON.stringify(a));
      showSuccessMessage(success(a));
    }
  };
  const mergedStyle = { ...{ fontSize: 24, paddingLeft: 10 }, ...style };
  return withTooltip(
    tip(data()),
    <FileCopy
      onClick={onCopy}
      htmlColor={htmlColor || mediumGray}
      style={mergedStyle}
    />
  );
}
